<template>
  <div>
    <van-cell title="海报" is-link :to="{ path: '/poster', query: { id: 1 } }" />
    <van-cell title="介绍买车" is-link :to="{ path: '/buyCar', query: { id: 1,userId:1111  } }" />
    <van-cell title="投票" is-link :to="{ path: '/vote', query: { type: 'text' } }" />
    <van-cell title="问卷" is-link :to="{ path: '/questionnaire', query: { id: 63, platform: 'ios', app: 'user', phone: '18210800834', preview: 1, orderNo:'',chassisNum: '',carModel:''  } }" />
    <van-cell title="问卷预览" is-link :to="{ path: '/questionnaire-preview', query: { id: 63, platform: 'ios', app: 'user', phone: '18210800834', preview: 1, orderNo:'',chassisNum: '',carModel:'', token: '910704c4f97c4da08baf9e2485120240' } }" />
    <van-cell title="推荐有礼" is-link :to="{ path: '/recommend', query: { platform: 'ios', app: 'user', phone: '18647409280', name: '周杰伦'} }" />
    <van-cell title="推荐有礼" is-link :to="{ path: '/recommend', query: { platform: 'ios', app: 'user', phone: '18647409280', name: '周杰伦'} }" />
    <van-cell title="邀请帮砍" is-link :to="{ path: '/cut', query: { app: 'user', patternId: 'S8', sponsorId: '18647409280'} }" />
    <van-cell title="迎中秋 赚积分" is-link :to="{ path: '/integral/index' }" />
    <van-cell title="迎中秋 赚积分" is-link :to="{ path: '/integral/share',query: { appType: 0 } }" />
    <van-cell title="国庆七天乐 积分赚不停" is-link :to="{ path: '/national-day/index' }" />
    <van-cell title="国庆七天乐 积分赚不停" is-link :to="{ path: '/national-day/share',query: { appType: 0 } }" />
    <van-cell title="金融专区" is-link :to="{ path: '/finance-zone', query: { id: 'fa5f67dc887c4e37bf44451c16ed1b9a', phone: '', name: '' } }" />
  </div>
</template>

<script>
export default {
  name: 'index',
  created() {
    // this.$router.push('/poster')
  }
}
</script>

<style scoped>

</style>
